import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { environment as ENV } from '../environments/environment.prod';
import { getCookie } from '../utils/auth';
@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
    constructor() { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let redirect_url = ENV.redirectUrl;
        redirect_url = btoa(redirect_url);
        redirect_url = encodeURIComponent(redirect_url);
        var jwt = { token: getCookie('MyToken') };
        if (!jwt || !jwt.token) {
            location.href = ENV.loginURL + "login/index/" + redirect_url;
        }

        let authReq = req.clone(
            {
                headers: req.headers.set("Authorization", "Bearer " + jwt.token).set('Content-Type', 'application/json')
            }
        );

        //send the newly created request
        return next.handle(authReq)
            .catch((error, caught) => {
                //intercept the respons error and displace it to the console 
                console.log("Error Occurred");
                console.log(error);
                //return the error to the method that called it
                if (error.status == 401) {
                    let redirect_url = ENV.redirectUrl;
                    redirect_url = btoa(redirect_url);
                    redirect_url = encodeURIComponent(redirect_url);
                    location.href = ENV.loginURL + "login/index/" + redirect_url;
                }
                if (error.error.heading == undefined) {
                    error.error.heading = "Connection error";
                    error.error.errorMessage = "Check your inter net connection or contact admin.";
                }
                return Observable.throw(error);
            }) as any;
    }
}


// WEBPACK FOOTER //
// ./src/app/http-interceptor.ts